<template>
	<div class="modal fade in" id="modal-default" role="alertdialog" :class="{show: (modalShowComputed > 0) ? true : false}">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="successFalse">
								<span aria-hidden="true" class="pull-right">×</span>
					</button>
				</div>
				<div class="modal-body text-center">
					<h4 class="modal-title">{{ title | translate | capitalize }}</h4>
					<p class="modal-text">{{  message  | translate | capitalize }}</p>
				</div>
				<div class="modal-footer">
					<form @submit.prevent="activePollChange()"  class="form-poll-status">
						<div class="form__group submit__content">
							<button type="submit">
								{{ 'publish' | translate | capitalize  }}
							</button>
						</div>
					</form>
				</div>
		</div>
	</div>
</div>
</template>
<script>
	export default {
		name: 'modal',
		props: {
			success: {
				type: Boolean,
				required: false,
			},
			message: {
				type: String,
				required: false,
			},
			title: {
				type: String,
				required: false,
			},
			pollId: {
				type: Number,
				required: false,
			},
		},
		data() {
			return {
				modalShow: 0,
			};
		},
		computed: {
			modalShowComputed() {
				this.modalShow = this.pollId;
				return this.modalShow;
			},
		},
		watch: {
			modalShow() {
				this.modalShow = this.pollId;
			},
		},
		methods: {
			successFalse() {
				this.$emit('close');
			},
			activePollChange() {
				const session = {
					apiKey: sessionStorage.getItem('apiKey'),
					userId: sessionStorage.getItem('userId'),
					poll_id: this.pollId,
					status_id: 1,
				};

				this.$store.dispatch('editPollRegister', session).then(() => {
					this.$root.$emit('eventing');
					this.$emit('close');
				});
			},
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/components/modal/modal.vue